// @ts-nocheck - GTM official code, don't check
/** biome-ignore-all lint/complexity/useDateNow: GTM official code, don't check */
/** biome-ignore-all lint/style/useTemplate:GTM official code, don't check */

/**
 * @param {string | null} containerId
 * @returns {void}
 */
export function init(containerId) {
	if (!containerId) return;

	// --- official snippet (leave it as-is) ---
	((w, d, s, l, i) => {
		w[l] = w[l] || [];
		w[l].push({ event: 'gtm.js', 'gtm.start': new Date().getTime() });
		var f = d.getElementsByTagName(s)[0],
			j = d.createElement(s),
			dl = l !== 'dataLayer' ? '&l=' + l : '';
		j.async = true;
		j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
		f.parentNode.insertBefore(j, f);
	})(window, document, 'script', 'dataLayer', containerId);
	// --- end snippet ---
}
